
class MainSearch extends HTMLElement {

  constructor(){
    super();
    this.init();
  }

  init = () => {
    this.saveSearch();
  }

  saveSearch = () => {
    if(!this.isSearched()){
      const saved = Utils.getSearched();
      saved.unshift(this.dataset.query);
      localStorage.setItem(Utils.SEARCHED, saved.join(','));
      window.dispatchEvent(new CustomEvent(Utils.SEARCH_SUBMITTED, { detail: this.dataset.query }));
    }
  }

  isSearched = () => {
    const saved = Utils.getSearched();
    var found = false;
    saved.forEach((item) => {
      if(item == this.dataset.query){
        found = true;
        return;
      }
    });
    return found;
  }
  
}
if (!window.customElements.get("main-search")) {
  window.customElements.define("main-search", MainSearch);
}